var _defs, _ellipse, _rect, _g, _defs2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorPage = function SvgErrorPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 95,
    viewBox: "0 0 208 95"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath4668430209"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L208 0L208 95L0 95L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 0)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath4668430209)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 6,
    rx: 27,
    ry: 6,
    transform: "matrix(1 0 0 1 76 83)",
    fill: "rgb(113, 113, 238)",
    opacity: 0.23
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask8195865389",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 36.5,
    ry: 36.5,
    transform: "matrix(1 0 0 1 66 17)",
    fill: "rgb(255, 255, 255)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8195865389)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    transform: "matrix(1 0 0 1 66 17)",
    fill: "rgb(184, 184, 251)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient6698092897",
    gradientTransform: "matrix(0 -33.0041 33.0041 0 9.99992 32.9773)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(255, 255, 255)",
    stopOpacity: 0.10196079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45.133 10.4755C43.281 6.51241 39.416 3.99051 35.173 3.97681C32.809 3.98211 30.511 4.77751 28.617 6.24511C26.363 1.68301 21.469 -0.775993 16.624 0.219307C11.779 1.21461 8.15597 5.42311 7.74698 10.5322C2.53438 12.2394 -0.699921 17.6366 0.129181 23.244C0.958175 28.8514 5.60297 32.9936 11.068 33L41.904 33C47.401 33.0108 52.074 28.8344 52.879 23.1902C53.685 17.546 50.38 12.1426 45.116 10.4982L45.133 10.4755Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 96 50)",
    fill: "url(#linearGradient6698092897)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4267816374",
    gradientTransform: "matrix(0 -19.0023 19.0023 0 5.50025 18.9869)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(255, 255, 255)",
    stopOpacity: 0.10196079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M25.5468 6.03139C24.4988 3.74958 22.311 2.29749 19.9092 2.28968C18.5714 2.29268 17.2701 2.75068 16.1982 3.59568C14.9226 0.968985 12.1525 -0.446815 9.4098 0.126286C6.6672 0.699286 4.6166 3.12239 4.3849 6.06398C1.4346 7.04688 -0.396103 10.1544 0.0730972 13.3829C0.542396 16.6114 3.1714 18.9963 6.2651 19L23.7191 19C26.8307 19.0062 29.4756 16.6016 29.9317 13.3519C30.3879 10.1022 28.5171 6.99118 25.5375 6.04438L25.5468 6.03139Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 69 38)",
    fill: "url(#linearGradient4267816374)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L15.6499 24.0936L0.8605 29.354L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 56.6836 63.1543)",
    fill: "rgb(102, 227, 153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8569 0L13.6969 22.8411L0 20.5048L12.8569 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 97.6911 67.7595)",
    fill: "rgb(113, 113, 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L13.966 21.8308L0 28.737L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 110.316 67.7456)",
    fill: "rgb(148, 148, 251)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.233 0L29.8302 48.1191L0 43.3408L28.233 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 53.3435 48.3661)",
    fill: "rgb(113, 113, 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L30.9192 41.6402L1.6314 48.1211L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 81.1758 48.3423)",
    fill: "rgb(148, 148, 251)"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9522422865"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L27 0L27 27L0 27L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 113 15)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9522422865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5714C1.3411e-07 14.7668 1.12973 17.4942 3.38919 19.7537C5.64866 22.0131 8.37607 23.1429 11.5714 23.1429C14.7668 23.1429 17.4942 22.0131 19.7537 19.7537C22.0131 17.4942 23.1429 14.7668 23.1429 11.5714C23.1429 8.37607 22.0131 5.64865 19.7537 3.38919C17.4942 1.12973 14.7668 0 11.5714 0C8.37607 0 5.64866 1.12973 3.38919 3.38919C1.12973 5.64866 0 8.37607 0 11.5714Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 114.929 16.9274)",
    fill: "rgb(249, 51, 57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05461 0.425354L8.42455 7.08646C8.95504 7.64121 8.94292 8.18383 8.38817 8.71432L8.38678 8.71565C7.83204 9.24615 7.28942 9.23402 6.75892 8.67928L0.388981 2.01817C-0.141514 1.46343 -0.12939 0.920809 0.425354 0.390314L0.426748 0.388981C0.981492 -0.141514 1.52411 -0.12939 2.05461 0.425354Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 122.091 23.949)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67928 2.05461L2.01817 8.42455C1.46343 8.95504 0.92081 8.94292 0.390314 8.38817L0.388982 8.38678C-0.141513 7.83204 -0.129389 7.28942 0.425354 6.75892L7.08646 0.388981C7.64121 -0.141514 8.18382 -0.12939 8.71432 0.425354L8.71565 0.426748C9.24615 0.981492 9.23402 1.52411 8.67928 2.05461Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 121.947 24.0914)",
    fill: "rgb(255, 255, 255)"
  })))));
};
export default SvgErrorPage;